import { render, staticRenderFns } from "./LaboratoriesComponent.vue?vue&type=template&id=60c91258&scoped=true"
import script from "./LaboratoriesComponent.vue?vue&type=script&lang=js"
export * from "./LaboratoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./LaboratoriesComponent.vue?vue&type=style&index=0&id=60c91258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c91258",
  null
  
)

export default component.exports